import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';

// Resolve the tenantId for the current session.
// Strategy: prefer localStorage.adminUser.tenantId, otherwise read userTenants/{uid}.
export async function resolveTenantId() {
  let tenantId = null;
  const adminRaw = localStorage.getItem('adminUser');
  if (adminRaw) {
    try { tenantId = JSON.parse(adminRaw).tenantId; } catch (e) { /* ignore */ }
  }

  if (!tenantId && auth && auth.currentUser) {
    try {
      const utRef = doc(db, `userTenants/${auth.currentUser.uid}`);
      const utSnap = await getDoc(utRef);
      if (utSnap.exists()) {
        const ut = utSnap.data();
        tenantId = ut.tenantId || (ut.tenantIds && ut.tenantIds[0]);
      }
    } catch (e) {
      // bubble up by returning null — callers can decide how to handle
      console.warn('resolveTenantId: failed to read userTenants', e);
    }
  }

  if (!tenantId) {
    // throw here so callers can decide; some callers may want to handle missing tenant gracefully
    throw new Error('Tenant not found');
  }

  return tenantId;
}

export async function tryResolveTenantId() {
  try { return await resolveTenantId(); } catch (e) { return null; }
}
